import { __exports as styles } from '../../../../_virtual/styles.js';
export { __exports as default } from '../../../../_virtual/styles.js';
Object.defineProperty(styles, "__esModule", {
  value: true
});
styles.containerStyleDefault = {
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  height: '100%'
};

// Overrides containerStyleDefault properties
styles.containerStyleAutoHeight = {
  height: 'auto'
};
styles.viewStyleDefault = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'scroll',
  WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
styles.viewStyleAutoHeight = {
  position: 'relative',
  top: undefined,
  left: undefined,
  right: undefined,
  bottom: undefined
};
styles.viewStyleUniversalInitial = {
  overflow: 'hidden',
  marginRight: 0,
  marginBottom: 0
};
styles.trackHorizontalStyleDefault = {
  position: 'absolute',
  height: 6
};
styles.trackVerticalStyleDefault = {
  position: 'absolute',
  width: 6
};
styles.thumbHorizontalStyleDefault = {
  position: 'relative',
  display: 'block',
  height: '100%'
};
styles.thumbVerticalStyleDefault = {
  position: 'relative',
  display: 'block',
  width: '100%'
};
styles.disableSelectStyle = {
  userSelect: 'none'
};
styles.disableSelectStyleReset = {
  userSelect: ''
};